import { render, staticRenderFns } from "./DoKubTab.vue?vue&type=template&id=bedce6fc&"
import script from "./DoKubTab.vue?vue&type=script&lang=js&"
export * from "./DoKubTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports